import { useItemSet } from '@exam-management/common/item-set-provider';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { FormTextField, ReadonlyField } from '@shared/components';
import { useHasPermission } from '@shared/permissions';

import { BaseItemSetInformationSection } from '../../components';
import { EDITABLE_ITEM_SET_QUESTION_DETAILS_STATUSES } from '../../constants';

export default function ItemSetInformationSection() {
  const { itemSet } = useItemSet();

  const hasUpdatePermission = useHasPermission(APP_PERMISSIONS.QBANK.QUESTION.UPDATE);

  const isEditableByStatus = EDITABLE_ITEM_SET_QUESTION_DETAILS_STATUSES.includes(itemSet.status);
  const isEditable = isEditableByStatus && hasUpdatePermission;

  return (
    <BaseItemSetInformationSection>
      {isEditable ? (
        <FormTextField label='Item Set Name' placeholder='กรอกชื่อ Item Set' name='details.name' />
      ) : (
        <ReadonlyField label='Item Set Name' content={itemSet.name} />
      )}
    </BaseItemSetInformationSection>
  );
}
